import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth-context";


const ResponsiveAppBar = () => {
    const { user, logOut } = useAuth();

    const navigate = useNavigate();

    const buttonNames = ["EXPLIST", "EXPCREATE"];

    const [menuActive, setMenuActive] = useState("EXPLIST");

    const hadleClickMenu = (event) => {
        if (event.target.name === buttonNames[0]) {
            setMenuActive(buttonNames[0]);
            navigate("/experiments/list");
        }
        if (event.target.name === buttonNames[1]) {
            setMenuActive(buttonNames[1]);
            navigate("/experiments/create");
        }
    };

    const handleLogoutMenu = () => {
        console.log("logout");
        logOut().then(resp => {
            navigate("./login");
        }).catch(error => {
            console.log(error);
        });
    };

    return (
        <>
            {user && (
                <div className="nav-bar-container">
                    <AppBar position="fixed">
                        <Container maxWidth="xl">
                            <Toolbar>
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        display: { xs: "none", md: "flex" },
                                    }}>
                                    <Button
                                        name={buttonNames[0]}
                                        key={buttonNames[0]}
                                        onClick={hadleClickMenu}
                                        className={
                                            menuActive === buttonNames[0]
                                                ? "menu-active"
                                                : "menu-inactive"
                                        }
                                        sx={{
                                            my: 2,
                                            color: "white",
                                            display: "block",
                                        }}>
                                        {"Experimentos"}
                                    </Button>
                                    <Button
                                        name={buttonNames[1]}
                                        key={buttonNames[1]}
                                        onClick={hadleClickMenu}
                                        className={
                                            menuActive === buttonNames[1]
                                                ? "menu-active"
                                                : "menu-inactive"
                                        }
                                        sx={{
                                            my: 2,
                                            color: "white",
                                            display: "block",
                                        }}>
                                        {"Crear"}
                                    </Button>
                                </Box>

                                <Box sx={{ flexGrow: 0 }}>
                                    <Button
                                        key="logout"
                                        onClick={handleLogoutMenu}
                                        sx={{
                                            my: 2,
                                            color: "white",
                                            display: "block",
                                        }}>
                                        {"Salir"}
                                    </Button>
                                </Box>
                            </Toolbar>
                        </Container>
                    </AppBar>
                </div>
            )}
        </>
    );
};
export default ResponsiveAppBar;
